import React from "react";
import "./styles.scss";
import DeskTop from "./desktopHeader";
import Mobile from "./mobileHeader";
function Header() {
  //Header
  return (
    <div className="Header">
      <div className="Header-desktop">
        <DeskTop />
      </div>
      <div className="Header-mobile">
        <Mobile />
      </div>
    </div>
  );
}
export default Header;
